import React, { useState, useEffect } from 'react'
import { Spin } from 'antd'


export const LoadingIndicator = (props) => {

  const { text } = props
  
  return (
    <div className="loading" style={{margin: 50}}>
      <Spin tip={text} size={`${props.size || "large"}`}>
        <div className="content" />
      </Spin>
    </div>
  )
}
